export default __webpack_public_path__ + "static/media/curriculum.4c08c585.pdf";